import { Component, HostListener, Input } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { AuthService } from '../../core/auth.service';
import { DialogButtonBase } from '../../shared/base/dialog-button-base';
import { QuestionBase } from '../../shared/dynamic-form/shared/question-base';
import { TextboxQuestion } from '../../shared/dynamic-form/shared/question-textbox';
import { MESSAGE_COMMON_ERROR } from '../../shared/message';
import { User } from '../shared/user';
import { MESSAGE_USER_UPDATE_PROFILE_SUCCESS } from '../shared/user-message';

@Component({
  selector: 'app-user-update-profile-button',
  template: '<ng-content></ng-content>'
})
export class UserUpdateProfileButtonComponent extends DialogButtonBase {
  @Input() user: User;

  constructor(dialog: MatDialog, snackBar: MatSnackBar, private authService: AuthService) {
    super(dialog, snackBar);
  }

  @HostListener('click') onClick() {
    this.openDialog();
  }

  openDialog(): void {
    super.openDialog(this.title, this.questions);
  }

  async onSubmit(_user: User): Promise<any> {
    try {
      this.user.name = _user.name;
      this.authService.updateProfile(this.user);
      this.closeDialog();
      this.openSnackBar(MESSAGE_USER_UPDATE_PROFILE_SUCCESS);
    } catch (e) {
      this.openSnackBar(MESSAGE_COMMON_ERROR);
    }
  }

  private get title(): string {
    return '개인 정보 수정';
  }

  private get questions(): Array<QuestionBase<any>> {
    return [
      new TextboxQuestion({
        key: 'name',
        label: '이름',
        value: this.user.name,
        required: true
      })
    ];
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/users/user-update-profile-button/user-update-profile-button.ts